import * as React from "react";
import { forwardRef } from "react";
const SvgInactiveNicojinIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 20.9999C16.9706 20.9999 21 16.9705 21 11.9999C21 7.02938 16.9706 2.99994 12 2.99994C7.02944 2.99994 3 7.02938 3 11.9999C3 13.4876 3.36093 14.8909 4 16.1271L3 20.9999L7.8728 19.9999C9.10904 20.639 10.5124 20.9999 12 20.9999Z", stroke: "#BDBDBD", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgInactiveNicojinIcon);
export { ForwardRef as ReactComponent };
